import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FastField, ErrorMessage } from 'formik';
import styled from 'styled-components';
import { withContentRect } from 'react-measure';
import round from 'lodash/round';

import Box from '../Box';
import Text from '../Text';
import Image from '../Image';
import TextInput from './TextInput';

import checkImage from '../utils/checkImage';

const percentage = (n) => `${round(n * 100, 4)}%`;

const InvisibleInput = styled(TextInput)`
  input, textarea {
    font-size: 1em;
    background: none;
    border: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: inherit;
    padding: 0.25rem;
    overflow: hidden;
  }
`;

class TextOnPicture extends PureComponent {
  constructor(props) {
    super(props);
    const { texts: { width, height, boxes }, name } = props;
    this.names = boxes.map((t, index) => `${name}-${index}`);
    this.boxes = boxes.map((box) => ({
      left: percentage(box.x / width),
      top: percentage(box.y / height),
      width: percentage(box.width / width),
      height: percentage(box.height / height),
      textAlign: box.textAlign,
      fontSize: `${box.fontSize}em`,
      fontWeight: box.fontWeight,
      color: box.color,
      multiLine: box.multiLine,
    }));
  }

  componentDidMount() {
    this.props.measure();
  }

  render() {
    const {
      name,
      label,
      src,
      texts,
      required,
      values,
      measure,
      measureRef,
      contentRect,
      randomID,
      onChange,
      onBlur,
      value,
      readOnly,
      disabled,
      ...props
    } = this.props;
    return (
      <Box {...props}>
        <Box position="relative" mx="0.5em">
          <Image src={checkImage(src)} />
          <Box
            position="absolute"
            top="0"
            left="0"
            right="0"
            bottom="0"
            ref={measureRef}
            style={{ fontSize: contentRect.bounds.width && (contentRect.bounds.width / texts.width)}}
          >
            {this.boxes.map(({ multiLine, ...attr }, index) => (
              <FastField key={index} name={this.names[index]}>
                {({ field }) => (
                  <Box
                    position="absolute"
                    border="2px dotted"
                    borderColor="black"
                    {...attr}
                  >
                    <InvisibleInput
                      textarea={multiLine}
                      autoComplete="off"
                      px="0"
                      placeholder=""
                      disabled={disabled}
                      readOnly={readOnly}
                      preventSubmit
                      {...field}
                    />
                    <ErrorMessage name={field.name}>
                      {msg => (
                        <Box position="absolute">
                          <Text fontSize="1rem" bg="warn" color="white">{msg}</Text>
                        </Box>
                      )}
                    </ErrorMessage>
                  </Box>
                )}
              </FastField>
            ))}
          </Box>
        </Box>
      </Box>
    );
  }
}

TextOnPicture.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  src: PropTypes.string.isRequired,
  texts: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    boxes: PropTypes.arrayOf(
      PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number,
        width: PropTypes.number,
        height: PropTypes.number,
        fontSize: PropTypes.number,
        color: PropTypes.string,
      }),
    ).isRequired,
  }),
  required: PropTypes.bool,
  values: PropTypes.object,
  measure: PropTypes.func,
  measureRef: PropTypes.func,
  contentRect: PropTypes.object,
};

export default withContentRect('bounds')(TextOnPicture);
